import { STD_CATS, PAYMENT_METHODS } from "../constants";
import { today, uid2 } from "./formatters";
import { sanitizeText, sanitizeAmount, sanitizeDate } from "./security";

export const RECURRING_FREQUENCIES = [
  { id: "weekly", label: "Weekly" },
  { id: "monthly", label: "Monthly" },
  { id: "yearly", label: "Yearly" }
];

export function addPeriod(dateStr, frequency) {
  const d = new Date(`${dateStr || today()}T00:00:00`);
  if (Number.isNaN(d.getTime())) return today();
  if (frequency === "weekly") d.setDate(d.getDate() + 7);
  else if (frequency === "yearly") d.setFullYear(d.getFullYear() + 1);
  else d.setMonth(d.getMonth() + 1);
  return d.toISOString().split("T")[0];
}

export function normalizeRecurringRule(rule = {}) {
  const type = rule.type === "income" ? "income" : "expense";
  const cats = STD_CATS[type] || STD_CATS.expense;
  const category = cats.some(c => c.l === rule.category) ? rule.category : cats[0].l;
  const frequency = ["weekly", "monthly", "yearly"].includes(rule.frequency) ? rule.frequency : "monthly";
  const amount = sanitizeAmount(rule.amount);
  return {
    id: sanitizeText(rule.id, 120) || uid2(),
    title: sanitizeText(rule.title || category || "Recurring entry", 80) || "Recurring entry",
    type,
    category,
    amount: amount > 0 ? amount : 0,
    frequency,
    nextDate: sanitizeDate(rule.nextDate) || today(),
    paymentMethod: PAYMENT_METHODS.includes(rule.paymentMethod) ? rule.paymentMethod : "",
    note: sanitizeText(rule.note, 500),
    active: rule.active !== false,
    createdAt: rule.createdAt || new Date().toISOString(),
    lastPostedAt: rule.lastPostedAt || ""
  };
}

export function ruleToTransaction(rule = {}) {
  const r = normalizeRecurringRule(rule);
  return {
    id: uid2(),
    type: r.type,
    category: r.category,
    amount: r.amount,
    date: r.nextDate || today(),
    paymentMethod: r.paymentMethod || "",
    note: [r.title, r.note, "Recurring"].filter(Boolean).join(" · "),
    recurringRuleId: r.id
  };
}

export function getDueRecurringRules(rules = [], asOf = today()) {
  return (rules || [])
    .map(normalizeRecurringRule)
    .filter(r => r.active && r.amount > 0 && r.nextDate && r.nextDate <= asOf);
}
